import React from "react";
import MainFrame from "@/Layout/Layout";
import { SliderSection } from "@/pages/home/components/SliderSection";
import { MainPartnersSection } from "@pages/home/components/MainPartnersSection";
import { SelfSellingSection } from "@pages/home/components/SelfSellingSection";
import { SimplifiedContactForm } from "@pages/contact/ContactUsView";
import Seo, { organizationJsonLd } from "@/components/Seo";

const HomeView: React.FC = () => {
  return (
    <MainFrame>
      <Seo
        title="Restart Design & Consulting | Automação Industrial para Óleo & Gás"
        description="Soluções em automação industrial para Óleo & Gás: válvulas industriais, atuadores pneumáticos, sensores de monitoramento, conexões para tubulação e serviços especializados. Anchieta - ES, Brasil."
        path="/"
        jsonLd={organizationJsonLd}
      />
      <SliderSection />
      <MainPartnersSection />
      <SelfSellingSection />
      <SimplifiedContactForm />
    </MainFrame>
  );
};

export default HomeView;
